import { useCallback, useState } from "react";
import { isEqual } from "lodash-es";

export function useDirtyCheck<T>(variables: T) {
  const [lastVariables, setLastVariables] = useState<T | null>(null);

  const isDirty = !isEqual(lastVariables, variables);

  const markExecuted = useCallback(() => {
    setLastVariables(variables);
  }, [variables]);

  return { isDirty, markExecuted };
}
